import type { AdminTournamentBracketMatch } from "../services/eventRegistrationAdminService";

export type TournamentOperationCategory = {
  categoryKey: string;
  categoryName: string;
};

export type MatchFormat = "single_set_6" | "single_set_9" | "bo3" | "bo5";

export type ScoreSetDraft = {
  gamesA: string;
  gamesB: string;
  tieBreakA: string;
  tieBreakB: string;
  isMatchTieBreak: boolean;
};

export type TournamentBracketBlock = {
  id: string;
  title: string;
  subtitle: string;
  kind: "group" | "round";
  isSeedHead?: boolean;
  teams: Array<{
    registrationId: number;
    label: string;
    isSeedHead: boolean;
    seedRank?: number | null;
  }>;
  matches: AdminTournamentBracketMatch[];
};

export const MATCH_FORMAT_OPTIONS: Array<{
  value: MatchFormat;
  label: string;
}> = [
  { value: "single_set_6", label: "1 set de 6 games" },
  { value: "single_set_9", label: "1 set longo" },
  { value: "bo3", label: "Melhor de 3 sets" },
  { value: "bo5", label: "Melhor de 5 sets" },
];

export const UNASSIGNED_COURT = "A definir";
